import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './components/AuthContext.js';
import { FilenameProvider } from './components/FilenameContext.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FilenameProvider>
        <App />
      </FilenameProvider>
    </AuthProvider>
  </React.StrictMode>
);
if (process.env.NODE_ENV === 'production') {
  console.log = function () { };
  console.warn = function () { };
  console.error = function () { };
}
